import { createFileRoute } from "@tanstack/react-router";

import { PovazniAktiPage } from "../about_.povazni-akti";

export const Route = createFileRoute("/en/about_/povazni-akti")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Important Acts | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"List of important acts, statutes, and bylaws of Makedonijaturist AD. Transparency and corporate governance.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/about/povazni-akti",
			},
		],
	}),
	component: PovazniAktiPage,
});
